// Клиентский антиспам отправки реакций (только оперативная память, по
// требованию задачи): две отправки с интервалом меньше 10 секунд ставят блок
// на следующие 10 секунд. Сбрасывается перезагрузкой страницы вместе с
// модулем — персистентности нет намеренно

const MIN_INTERVAL_BETWEEN_SENDS_MS = 10000;
const BLOCK_DURATION_MS = 10000;

let lastSentAt = 0;
let blockedUntil = 0;

// Оставшиеся секунды блока (0 — отправка разрешена)
export const getReactionBlockRemainingSeconds = () => {
  const remainingMs = blockedUntil - Date.now();
  return remainingMs > 0 ? Math.ceil(remainingMs / 1000) : 0;
};

// Оставшиеся миллисекунды блока — точность нужна для длительности CSS-анимации
// полоски кулдауна (секундная точность getReactionBlockRemainingSeconds для
// этого слишком груба)
export const getReactionBlockRemainingMs = () => Math.max(0, blockedUntil - Date.now());

// Вызывается при каждой УСПЕШНОЙ отправке: вторая отправка быстрее чем через
// 10 секунд после предыдущей включает 10-секундный блок
export const registerReactionSent = () => {
  const now = Date.now();
  if (lastSentAt > 0 && now - lastSentAt < MIN_INTERVAL_BETWEEN_SENDS_MS) {
    blockedUntil = now + BLOCK_DURATION_MS;
  }
  lastSentAt = now;
};
